// vendor libs
import 'react-hot-loader';
import React from 'react';
import {render} from 'react-dom';

// Components
import './index.css';
import App from './App';

render(<App />, document.getElementById('app')
);
